// extracted by mini-css-extract-plugin
module.exports = {"flexRow":"ydzGT","partner":"J0GwB","maskWrapper":"y-kfL","user":"UM+JZ","threeDotsButton":"_2+whu","employeesTable":"_5XpyB"};